import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "w-full p-6" }
const _hoisted_2 = { class: "bg-card rounded-lg shadow p-6" }
const _hoisted_3 = { class: "mb-6" }
const _hoisted_4 = { class: "mb-6 flex space-x-4" }
const _hoisted_5 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_6 = { class: "flex items-center space-x-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmailReviewModal = _resolveComponent("EmailReviewModal")!
  const _component_SpreadsheetReviewModal = _resolveComponent("SpreadsheetReviewModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[6] || (_cache[6] = _createElementVNode("h1", { class: "text-2xl font-bold mb-2" }, "Forecasting for PCO", -1)),
    _cache[7] || (_cache[7] = _createElementVNode("p", { class: "text-muted-foreground mb-6" }, "Analyze and manage financial forecasts for the Planning and Controlling Office", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "text-xl font-semibold mb-4" }, "PCO Forecasting Dashboard", -1)),
        _cache[3] || (_cache[3] = _createElementVNode("p", { class: "text-muted-foreground mb-4" }, " Welcome to the PCO Forecasting dashboard. This specialized view is only accessible to users with the Head of PCO business role. ", -1)),
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "bg-accent/20 p-4 rounded-md mb-6" }, [
          _createElementVNode("p", { class: "font-medium" }, "Note: This is a placeholder component. The actual forecasting functionality will be implemented in future updates.")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openSpreadsheetReviewModal && _ctx.openSpreadsheetReviewModal(...args))),
            class: "px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          }, " Review Excel "),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openEmailReviewModal && _ctx.openEmailReviewModal(...args))),
            class: "px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          }, " Review Email ")
        ])
      ]),
      _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"grid grid-cols-1 md:grid-cols-2 gap-6\"><div class=\"bg-background rounded-md p-4 border border-border\"><h3 class=\"font-medium mb-2\">Monthly Forecast</h3><div class=\"h-40 bg-primary/10 rounded flex items-center justify-center\"><span class=\"text-muted-foreground\">Chart placeholder</span></div></div><div class=\"bg-background rounded-md p-4 border border-border\"><h3 class=\"font-medium mb-2\">Quarterly Forecast</h3><div class=\"h-40 bg-primary/10 rounded flex items-center justify-center\"><span class=\"text-muted-foreground\">Chart placeholder</span></div></div><div class=\"bg-background rounded-md p-4 border border-border md:col-span-2\"><h3 class=\"font-medium mb-2\">Annual Forecast Comparison</h3><div class=\"h-40 bg-primary/10 rounded flex items-center justify-center\"><span class=\"text-muted-foreground\">Chart placeholder</span></div></div></div>", 1)),
      (_ctx.processStatus)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", {
                class: _normalizeClass(["w-3 h-3 rounded-full", {
              'bg-blue-500 animate-pulse': _ctx.processStatus === 'active',
              'bg-green-500': _ctx.processStatus === 'completed',
              'bg-red-500': _ctx.processStatus === 'error'
            }])
              }, null, 2),
              _createElementVNode("span", {
                class: _normalizeClass(["text-sm", {
              'text-blue-700': _ctx.processStatus === 'active',
              'text-green-700': _ctx.processStatus === 'completed',
              'text-red-700': _ctx.processStatus === 'error'
            }])
              }, _toDisplayString(_ctx.processStatus === 'active' ? 'Processing forecast data...' :
              _ctx.processStatus === 'completed' ? 'Forecast process completed' :
              'Error in forecast process'), 3)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_EmailReviewModal, {
      "is-open": _ctx.showEmailReviewModal,
      "process-step-type": _ctx.currentProcessStepType,
      "recipient-email": _ctx.recipientEmail,
      "template-variables": _ctx.templateVariables,
      onClose: _ctx.closeEmailReviewModal,
      onSendSuccess: _ctx.handleEmailSent
    }, null, 8, ["is-open", "process-step-type", "recipient-email", "template-variables", "onClose", "onSendSuccess"]),
    _createVNode(_component_SpreadsheetReviewModal, {
      "is-open": _ctx.showSpreadsheetReviewModal,
      onClose: _ctx.closeSpreadsheetReviewModal,
      onSave: _ctx.handleSpreadsheetSaved
    }, null, 8, ["is-open", "onClose", "onSave"])
  ]))
}